import React, { useEffect } from 'react';
import Cookies from 'js-cookie';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import { Routes } from './Routes';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import { GoogleOAuthProvider } from '@react-oauth/google';
import SignupContextProvider from './context/SignupContext/SignupContextProvider';
import CommunityContextProvider from './context/CommunityContext/CommunityContextProvider';
import CommonModalContextProvider from './context/CommonModalContext/CommonModalContextProvider';

const theme = createTheme({
  typography: {
    fontFamily: [
      'Arial',
    ].join(','),
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
    },
  },
});


function App() {
  useEffect(() => {
    const handleStorage = (event) => {
      if (event.key === "logout-event") {
        window.location.replace("/");
      }
    };

    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener("storage", handleStorage);
    };
  }, []);
  return (
    <div className="App">
      <GoogleOAuthProvider clientId='1096351929813-b3sqsgi9t95dfbr7jhsruvsfvh8q6iac.apps.googleusercontent.com'>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <SignupContextProvider>
              <CommunityContextProvider>
                <CommonModalContextProvider>
                  <Routes />
                </CommonModalContextProvider>
              </CommunityContextProvider>
            </SignupContextProvider>
          </BrowserRouter>
        </ThemeProvider>
      </GoogleOAuthProvider>
    </div>
  );
}

export default App;
